import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          {/* Colonne 1 - Branding */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/1b5af7966bd8760470a3b6a5437d75be.png"
              alt="ADF Biomédical"
              className="h-12 w-auto mb-4"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              Fournisseur de dispositifs médicaux en Algérie
            </p>
          </div>

          {/* Colonne 2 - Liens rapides */}
          <div>
            <h4 className="font-bold text-white mb-4">Liens rapides</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Solutions */}
          <div>
            <h4 className="font-bold text-white mb-4">Solutions</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Soins respiratoires
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Cardiologie
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Équipements hospitaliers
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  Diagnostic
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 4 - Informations légales */}
          <div>
            <h4 className="font-bold text-white mb-4">Informations légales</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/legal/mentions-legales" className="text-text-secondary hover:text-[#E31B23] transition-colors cursor-pointer">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/legal/politique-confidentialite" className="text-text-secondary hover:text-[#E31B23] transition-colors cursor-pointer">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/legal/politique-cookies" className="text-text-secondary hover:text-[#E31B23] transition-colors cursor-pointer">
                  Politique de cookies
                </Link>
              </li>
              <li>
                <Link to="/legal/conditions-utilisation" className="text-text-secondary hover:text-[#E31B23] transition-colors cursor-pointer">
                  Conditions d'utilisation
                </Link>
              </li>
              <li>
                <Link to="/legal/protection-donnees" className="text-text-secondary hover:text-[#E31B23] transition-colors cursor-pointer">
                  Protection des données
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 5 - Contact */}
          <div>
            <h4 className="font-bold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#E31B23] mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <span className="text-white/70 text-sm">
                  Local N01 Benghazi N16, Baraki, Alger, Algérie
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-[#E31B23] mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <a href="tel:+213770307905" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  +213 770 30 79 05
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#E31B23] mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:contact@adfbiomedical.dz" className="text-white/70 hover:text-[#E31B23] transition-colors duration-300 text-sm cursor-pointer">
                  contact@adfbiomedical.dz
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-white/60 text-center sm:text-left">
              © 2024 ADF Biomédical. Tous droits réservés.
            </p>
            <Link
              to="/"
              className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
            >
              Powered by BeneluxWeb
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
